import React, { useState } from "react";
import Button, { IconButton } from "./Button";
import { MdOutlineAttachment, MdDeleteOutline } from "react-icons/md";
import Modal from "./Modal";
import { useAtom } from "jotai";
import { messageCountAtom, ticketAtom } from "../store";
import useConversation from "../hooks/useConversation";
import { allowFileAttachment } from "../utils";
import { toast } from "react-toastify";

interface MessageTextFieldProps {
  handleClose: () => void;
}

const MessageTextField = ({ handleClose }: MessageTextFieldProps) => {
  const [data] = useAtom(ticketAtom);
  const [messageCount] = useAtom(messageCountAtom);
  const { sendMessage } = useConversation({ count: messageCount });
  const [value, setValue] = useState("");
  const [open, setOpen] = useState(false);

  const [filesArr, setFilesArr] = useState<File[]>([]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files || [];
    if (files.length) {
      if (allowFileAttachment(files[0])) {
        setFilesArr([...filesArr, files[0]]);
      } else toast.error("Please upload appropriate file size and type");
    }
  };

  const handleDelete = () => {
    setOpen(false);
  };

  const reset = () => {
    setValue("");
    setFilesArr([]);
  };

  const handleSave = async () => {
    const resetPageNumber = 1;
    sendMessage.send(
      {
        request_payload: { body: value, ticket_id: `${data?.ticket_id}` },
        file: [...filesArr],
      },
      resetPageNumber,
      reset
    );
  };

  return (
    <div className="chat-bx ti-cb">
      <div className="sender-heading-bx">
        <div className="flex-row"></div>
        <span onClick={handleClose} className="cursor-pointer">
          Close
        </span>
      </div>

      <textarea
        name="newMessage"
        id="newMessage"
        cols={20}
        rows={2}
        className="message-bx sh-mb"
        onChange={(e) => setValue(e.target.value)}
        value={value}
      ></textarea>

      <div className="attach-bx flex-between">
        <label className="btn btn-secondary">
          <MdOutlineAttachment
            size={23}
            style={{ transform: "rotate(-30deg)" }}
          />
          Attach file
          <input type="file" onChange={handleFileChange} hidden />
        </label>
        <Button
          type="submit"
          className="link btn"
          onClick={handleSave}
          disabled={value === "" || sendMessage.loading}
        >
          {sendMessage.loading ? "Sending..." : "Send"}
        </Button>
      </div>
      {filesArr.length ? (
        filesArr.map((file, idx) => {
          return (
            <div className="attach-name-cont" key={idx}>
              <span>{file.name}</span>
              <IconButton
                icon={<MdDeleteOutline color="#ACB5BD" size={23} />}
                onClick={() => {
                  // delete a file based on name
                  const newArr = filesArr.filter(
                    (item) => item.name !== file.name
                  );
                  setFilesArr(newArr);
                }}
              />
            </div>
          );
        })
      ) : (
        <p className="file-size-warning-text">
          <i>
            Note: Attached files shoule be either -- PDF, DOC, PNG, JPEG and
            must not be greater than 8mb
          </i>
        </p>
      )}
      <Modal open={open} onClose={() => setOpen(false)}>
        <div className="file-modal">
          <p>Are you sure you want to remove this file?</p>
          <div className="action-cont">
            <Button className="btn" onClick={handleDelete}>
              Yes
            </Button>
            <Button
              className="btn btn-secondary"
              onClick={() => setOpen(false)}
            >
              No
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MessageTextField;
